export default {"src":"/_next/static/media/bg.9b9d9a66.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};